import {WorkCenter, WorkCenterRestControllerApiFactory} from "arteco-api-client-ts";
import AppList, {AppListConfig} from "../../../../components/layout/list";
import {useApiManager} from "../../../../components/utils/api";
import {TableCell} from "@mui/material";
import {SoftChip} from "../../../../components/kit";
import {CALENDAR_LABELS} from "../holiday/labels";

export const WorkCenterListPage = () => {
	const apiManager = useApiManager();

	const listConfig: AppListConfig<WorkCenter> = {
		title: "Centros de trabajo",
		onClick: "/app/admin/employee/workcenter",
		headers: [
			{title: "Nombre"},
			{title: "Dirección"},
			{title: "Ciudad"},
			{title: "Calendario"},
			{title: "Estado"},
		],
		decorator: (bean: WorkCenter) =>
			<>
				<TableCell>{bean.name}</TableCell>
				<TableCell>{bean.address}</TableCell>
				<TableCell>{bean.city}</TableCell>
				<TableCell>{CALENDAR_LABELS[bean.calendar || ""] || bean.calendar}</TableCell>
				<TableCell>{bean.disabled ? <SoftChip tone="neutral" label="Desactivado"/> : <SoftChip tone="success" label="Activo"/>}</TableCell>
			</>,
		supplier: async (currentPage, size, term, showDismissed) => {

			const ctrl = apiManager.factory(WorkCenterRestControllerApiFactory);
			return ctrl.pageWorkCenter(currentPage, size, undefined, term, showDismissed);
		},
	};

	return (
		<>
			<AppList config={listConfig}/>
		</>
	);
};